import React from 'react'

import {
	Box,
	Button,
	Typography,
} from "@mui/material"

import ArrowBackIcon from "@mui/icons-material/ArrowBack"

import { Link } from "react-router-dom"
import { Trans } from "@lingui/macro"

export class PageWip extends React.Component<{}, {}>
{
	render() {
		return (
			<Box
				sx={{
					pt: 12,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}
			>
				<Typography mt={2} mb={5}>
					Pagina in lavorazione
				</Typography>

				<Link to="/">
					<Button variant="contained" startIcon={<ArrowBackIcon />}>
						<Trans id="buttons.back" comment="Back text on buttons">Indietro</Trans>
					</Button>
				</Link>
			</Box>
		)
	}
}
